import React from "react";
import aboutBG from "../../../assets/img/banner/aboutBG.jpg";
import { Link } from "react-router-dom";
import "./ServiceList.css";
import { CgArrowRight } from "react-icons/cg";

function ServiceList() {
  return (
    <>
      <section className="serviceList p-30">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="fisherman-content about">
                <h3>Welcome to EHL Life Sciences</h3>

                <p>
                  At EHL Life Sciences Pvt Ltd, we are dedicated to improving
                  animal health and farm productivity through high-quality
                  veterinary feed supplements specially formulated for cattle
                  and poultry. We understand the practical challenges Indian
                  farmers face, and our products are designed to support better
                  weight gain, stronger immunity, and improved overall health in
                  livestock and poultry—whether in small rural setups or large
                  commercial farms.
                </p>
                <p>
                  Our supplements are manufactured in ISO-certified,
                  GMP-compliant facilities. We use quality ingredients and
                  carefully tested formulations to ensure every product is safe,
                  effective, and consistent. From feed additives to
                  vitamin-mineral mixes, we focus on results that farmers can
                  see in their animals' performance and well-being.
                </p>
                <Link to="/about" className="commonBtn">
                  Know More <CgArrowRight />
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="aboutFigure">
                <img src={aboutBG} alt="About" className="img-fluid" />
                <span>
                  A Legacy of Care, Innovation, and Quality in Healthcare
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceList;
